// services/family.js — срокове около майчинство и бащинство (чл. 163–164в
// КТ) и неплатеният отпуск, който се зачита за стаж (чл. 160 КТ). Чисти
// функции само върху дати; календарът е през holidays.js. Обезщетенията
// (парите) са от ДОО и НЕ се смятат тук — калкулаторът дава сроковете,
// които кантората следи за клиентите си.

const holidays = require('./holidays');
const { addMonthsClamped } = require('./dismissal');

// колко календарни дни преди термина започва отпускът по чл. 163, ал. 1
const MATERNITY_TOTAL_DAYS = 410;
const MATERNITY_BEFORE_BIRTH_DAYS = 45;
// бащата — 15 календарни дни от изписването (чл. 163, ал. 8)
const FATHER_DISCHARGE_DAYS = 15;

function addYearsClamped(iso, years) { return addMonthsClamped(iso, years * 12); }

// Времевата линия по термин (и по раждане/изписване, ако са известни).
// Пропуснатите входове дават null в съответните полета.
function maternityTimeline(o) {
  const due = String(o.dueDate).slice(0, 10);
  const leaveStart = holidays.addDays(due, -MATERNITY_BEFORE_BIRTH_DAYS);
  const r = {
    leaveStart,
    // първият ден се брои → краят е +409, не +410
    day410End: holidays.addDays(leaveStart, MATERNITY_TOTAL_DAYS - 1),
    until2y: null, father15End: null, father2moUntil: null,
    notes: [
      'Ако раждането настъпи преди изтичане на 45-те дни, остатъкът се ползва след раждането (чл. 163, ал. 1).',
      'За 15-те дни на бащата се иска 6 месеца осигурителен стаж; обезщетенията са от ДОО.',
      'Двата месеца по чл. 164в са за баща/осиновител, който не е ползвал прехвърлени права (чл. 163, ал. 10 и др.).',
    ],
  };
  if (o.birthDate) {
    const birth = String(o.birthDate).slice(0, 10);
    r.until2y = addYearsClamped(birth, 2);       // отпуск за отглеждане — чл. 164
    r.father2moUntil = addYearsClamped(birth, 8); // чл. 164в — до навършване на 8 г.
  }
  if (o.dischargeDate) {
    r.father15End = holidays.addDays(String(o.dischargeDate).slice(0, 10), FATHER_DISCHARGE_DAYS - 1);
  }
  return r;
}

// ---- В5. Неплатен отпуск и стаж (чл. 160, ал. 3 КТ) ----

// До 30 работни дни в една календарна година се признават за трудов
// стаж; над това — само ако е предвидено в закон или акт на МС.
const UNPAID_COUNTED_LIMIT_DAYS = 30;

function unpaidLeaveSplit(o) {
  const days = Number(o.workDays) || 0;
  const counted = Math.min(days, UNPAID_COUNTED_LIMIT_DAYS);
  return { counted, notCounted: days - counted };
}

module.exports = {
  maternityTimeline, unpaidLeaveSplit,
  MATERNITY_TOTAL_DAYS, MATERNITY_BEFORE_BIRTH_DAYS, FATHER_DISCHARGE_DAYS,
  UNPAID_COUNTED_LIMIT_DAYS,
};
